import React from 'react';
import Header from '../components/Husk-n-spices/Header';
import ListItem from '../components/ListItem';
import { data } from '../HusknSpicesData/ProductFeedGradeVegetableAndGrainPowder';
import Footer from '../components/Husk-n-spices/Footer';

export default function SprayDrayedVegetablePowder() {
  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />
      {data
        .filter(i => i.type === 'SprayDrayedVegetablePowder')
        .map(spraydrayedvegetablepowder => {
          return (
            <ListItem
              name={spraydrayedvegetablepowder.name || 'No Name'}
              description={spraydrayedvegetablepowder.description || 'No Description'}
              ingredientValues={spraydrayedvegetablepowder.ingredientValues || 'No Ingredient Values'}
              image={spraydrayedvegetablepowder.image}
              id={spraydrayedvegetablepowder.id}
            />
          );
        })}
      <Footer />
    </div>
  );
}
